import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";

export function KPTTrainingKenya() {
  return (
    <div className="art-page">
      <SEO
        title="KPT Training Support — Kenya and Cambodia (Berkeley Air Monitoring Group, 2025)"
        description="In February 2025, CIRCODU supported Berkeley Air in delivering Kitchen Performance Test (KPT) training to research assistants in Kenya and Cambodia, demonstrating its expertise in KPT protocols and its role as a global training resource for clean cooking research."
        keywords="KPT training, Kitchen Performance Test training, Berkeley Air Monitoring Group, Kenya, Cambodia, clean cooking research, cookstove monitoring, carbon verification, CIRCODU, KPT training Kenya, KPT training Cambodia, Berkeley Air KPT training support, international KPT training, clean cooking research training, KPT methodological expertise, KPT capacity building, global clean cooking research community, KPT data quality, carbon verification training, cookstove programme monitoring training"
        url="/KPT-Training-Support-Kenya-and-Cambodia-Berkeley-Air-Monitoring-Group-2025"
        datePublished="2025-02-01"
      />

      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              KPT Training Support — Kenya and Cambodia (Berkeley Air)
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 01, 2025
            </div>
            <h1 className="art-title">
              KPT Training Support — Kenya and Cambodia (Berkeley Air Monitoring
              Group, 2025)
            </h1>
            <div className="texty">
              <h2 className="art-subheading">Overview</h2>
              <p>
                In February 2025, CIRCODU extended its capacity-building role
                internationally by supporting{" "}
                <strong>Berkeley Air Monitoring Group</strong> in delivering{" "}
                <strong>Kitchen Performance Test (KPT) training</strong> to
                research assistants in both <strong>Kenya</strong> and{" "}
                <strong>Cambodia</strong>. This assignment reflects the depth of
                CIRCODU's methodological expertise in KPT protocols — expertise
                developed over more than 15 years of field and laboratory work
                in Uganda — and its growing recognition as a training resource
                for the global clean cooking research community.
              </p>
              <h2 className="art-subheading">CIRCODU's Role</h2>
              <p>
                CIRCODU trainers worked alongside Berkeley Air to equip local
                research assistants in both countries with the skills needed to
                conduct Kitchen Performance Tests to international standards.
                The training covered:
              </p>
              <ol>
                <li>Theoretical foundations of KPT methodology.</li>
                <li>
                  Field data collection procedures and fuel weighing protocols.
                </li>
                <li>
                  Quality control processes for consistent, reproducible data.
                </li>
                <li>
                  Data recording requirements for carbon verification
                  submissions.
                </li>
              </ol>
              <p>
                By delivering this training simultaneously in two geographically
                and culturally distinct contexts — East Africa and Southeast
                Asia — CIRCODU demonstrated the transferability of its
                methodological knowledge beyond its Ugandan home base.
              </p>
              <h2 className="art-subheading">Significance</h2>
              <p>
                This assignment marks an important evolution in CIRCODU's
                identity: from Uganda's leading cookstove monitoring institution
                to a{" "}
                <strong>
                  globally recognised methodological training resource
                </strong>{" "}
                for the clean cooking research community. The quality of locally
                trained research assistants in countries adopting KPT
                methodologies has a direct bearing on the reliability of the
                global evidence base for cookstove programmes — and CIRCODU's
                contribution to that quality represents a lasting impact beyond
                Uganda's borders.
              </p>
            </div>
            <div className="art-cta">
              <p>
                For more information about CIRCODU's international training and
                capacity building services, contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
